import { Close } from '@mui/icons-material'
import {
  Box,
  Dialog,
  IconButton,
  Modal,
  Paper,
  PaperProps,
  Typography
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { PropsWithChildren } from 'react'

interface OwnProps {
  title: string
  open: boolean
  setOpen: (value: boolean) => void
  containerProps?: PaperProps
}

type AppProps = PropsWithChildren & OwnProps

const NivosModal: React.FC<AppProps> = props => {
  const { open, setOpen, children, title, containerProps } = props
  const isMobileView = useMediaQuery('(max-width:600px)')

  return (
    <>
      {!isMobileView && (
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            height={1}
            padding={isMobileView ? 1 : 2}
          >
            <Paper
              variant={'elevation'}
              sx={{
                width: isMobileView ? '100vw' : 'fit-content',
                height: isMobileView ? '100vh' : 'initial',
                minHeight: '50vh',
                maxHeight: isMobileView ? '100vh' : '90vh',
                maxWidth: isMobileView ? '100vw' : '1000px',
                overflow: 'auto',
                padding: isMobileView ? 0 : 4,
                borderRadius: 4
              }}
              elevation={8}
              {...containerProps}
            >
              <Box display={'flex'} paddingBottom={4}>
                <Box flexGrow={1}>
                  <Typography paddingLeft={1} variant={'h4'}>
                    {title}
                  </Typography>
                </Box>
                <Box display={'flex'} alignItems={'center'}>
                  <IconButton onClick={() => setOpen(false)}>
                    <Close color={'primary'} />
                  </IconButton>
                </Box>
              </Box>
              <Box>{children}</Box>
            </Paper>
          </Box>
        </Modal>
      )}
      {isMobileView && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullScreen
          sx={{ height: '100vh' }}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            height={'100vh'}
            padding={isMobileView ? 0 : 2}
          >
            <Paper
              variant={'elevation'}
              sx={{
                width: isMobileView ? '99vw' : 'fit-content',
                height: isMobileView ? '100vh' : 'initial',
                minHeight: '50vh',
                maxHeight: isMobileView ? '100vh' : '90vh',
                maxWidth: isMobileView ? '100vw' : '1000px',
                overflow: 'auto',
                padding: isMobileView ? 0 : 2
              }}
              elevation={8}
              {...containerProps}
            >
              <Box display={'flex'}>
                <Box flexGrow={1}>
                  <Typography
                    paddingY={1}
                    paddingLeft={1}
                    variant={isMobileView ? 'h4' : 'h3'}
                  >
                    {title}
                  </Typography>
                </Box>
                <Box display={'flex'} alignItems={'center'}>
                  <IconButton onClick={() => setOpen(false)}>
                    <Close color={'primary'} />
                  </IconButton>
                </Box>
              </Box>
              <Box>{children}</Box>
            </Paper>
          </Box>
        </Dialog>
      )}
    </>
  )
}

export default NivosModal
